import { type MessagePayload } from "@/shared/webworker";

import type { SeriesTruncation } from "../PlotDataStreamer";
import type { Extents } from "../PlotRenderer";

export enum PlotEvent {
  Error = "error",
  Initialized = "initialized",
  LoadingStateChange = "loading-state-change",
  Rendered = "rendered",
}

export interface RenderedAnnotation {
  id: string;
  type: "event";
  pixel: {
    x: number;
    y: number;
    width: number;
    height: number;
  };
  color: string;
}

export interface PlotEventPayloadMap {
  [PlotEvent.Error]: Error;
  [PlotEvent.Initialized]: undefined;
  [PlotEvent.LoadingStateChange]: {
    isLoading: PlotLoadingState;
  };
  [PlotEvent.Rendered]: {
    extents: Extents | null;
    annotations: RenderedAnnotation[];
    /** Series drawn only in part; see {@link PlotDataStreamer.truncatedSeries}. */
    truncations: SeriesTruncation[];
  };
}

export type PlotLoadingState = "foreground" | "background" | false;

export function isInitializedEvent(
  event: MessageEvent<MessagePayload>,
): event is MessageEvent<
  MessagePayload<PlotEvent, PlotEventPayloadMap[PlotEvent.Initialized]>
> {
  return event.data.type === PlotEvent.Initialized;
}

export function isLoadingStateChangeEvent(
  event: MessageEvent<MessagePayload>,
): event is MessageEvent<
  MessagePayload<PlotEvent, PlotEventPayloadMap[PlotEvent.LoadingStateChange]>
> {
  return event.data.type === PlotEvent.LoadingStateChange;
}

export function isRenderedEvent(
  event: MessageEvent<MessagePayload>,
): event is MessageEvent<
  MessagePayload<PlotEvent, PlotEventPayloadMap[PlotEvent.Rendered]>
> {
  return event.data.type === PlotEvent.Rendered;
}
